import { useMemo } from 'react';
import { useITopFiveApiV2EndpointsTopFiveGetTopFiveByIdGetTopFiveByIdEndpoint } from '@/api/api.generated';
import { QUERY_CONFIG } from '@/api/queryConstants';

type UseTopFiveDetailDataParams = {
  topFiveId?: number;
  enabled?: boolean;
};

export const useTopFiveDetailData = (params?: UseTopFiveDetailDataParams) => {
  const { topFiveId, enabled = true } = params || {};

  const shouldFetch = Boolean(enabled && topFiveId && topFiveId > 0);

  const result =
    useITopFiveApiV2EndpointsTopFiveGetTopFiveByIdGetTopFiveByIdEndpoint(
      topFiveId || 0,
      {
        query: {
          enabled: shouldFetch,
          staleTime: QUERY_CONFIG.STALE_TIME.MEDIUM,
          gcTime: QUERY_CONFIG.GC_TIME.MEDIUM,
          refetchOnWindowFocus: false,
          retry: QUERY_CONFIG.RETRY.MEDIUM,
        },
      }
    );

  const { data, isLoading, error } = result;

  const topFiveDetailData = useMemo(() => {
    const staffTopFive = data?.data?.staffTopFive;
    const permissions = data?.data?.permissions;
    const topFiveItems = staffTopFive?.topFives?.[0]?.topFiveItems || [];

    return {
      staffTopFive,
      topFiveItems,
      permissions,
    };
  }, [data]);

  return {
    topFiveDetailData,
    isLoading,
    error,
    refetch: result.refetch,
  };
};
